module.exports = __webpack_public_path__ + "static/media/sidebar-1.3a3df7ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sidebar-1.jpg
// module id = 637
// module chunks = 0